var formatTime;

import {
  hexToRgb,
  lightenDarkenColor
} from 'helpers/colors';

import colors from 'constants/colors';

formatTime = function(date) {
  return moment(date).format('h:mma');
};

angular.module('gym.calendar').controller('CalendarCtrl', ["gym", "loadingAnimation", "$document", "$scope", "$rootScope", "$state", "$stateParams", "$filter", "$compile", "$timeout", "$location", "CwStorage", "EmploymentService", "CalendarLastVisitedViewService", "EventService", "TrainersService", "FeatureAvailabilityService", "CalendarData", "MessageService", "GTMService", "ContrastColor", "locations", "selectedLocation", "eventTypes", "styles", function(gym, loadingAnimation, $document, $scope, $rootScope, $state, $stateParams, $filter, $compile, $timeout, $location, CwStorage, EmploymentService, CalendarLastVisitedViewService, EventService, TrainersService, FeatureAvailabilityService, CalendarData, MessageService, GTMService, ContrastColor, locations, selectedLocation, eventTypes, styles) {
  var defaultMonth, defaultView, displayItems, getInitialView, gym_config, handlePopoverHide, params, ref, ref1, refetchEvents, setDefaultDate;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.locations = locations.plain();
  $scope.selectedLocations = _.compact([selectedLocation]);
  $location.search('location_id', selectedLocation != null ? selectedLocation.id : void 0);
  $scope.instructors = TrainersService.get();
  $scope.eventTypes = eventTypes;
  $scope.styles = styles;
  $scope.queryParams = {
    general_filter: CwStorage.getItem('calendarGeneralFilter')
  };
  $scope.unableToManageOtherContacts = !$scope.permissions.manage_other_contacts;
  gym_config = gym.attributes.gym_config;
  CalendarLastVisitedViewService.set($state.current.name);
  getInitialView = function() {
    var defaultView;
    if ($stateParams.view === 'daily_agenda') {
      return 'basicDay';
    }
    defaultView = CwStorage.getItem('calendarDefaultView') === 'basicDay' && $stateParams.view === 'calendar' ? void 0 : CwStorage.getItem('calendarDefaultView');
    return defaultView || (function() {
      switch (gym_config.internal_calendar_default_view) {
        case 'week':
          return 'agendaWeek';
        case 'daily_agenda':
          return 'basicDay';
        default:
          return 'month';
      }
    })();
  };
  defaultView = getInitialView();
  defaultMonth = CwStorage.getItem('calendarDefaultMonth') ? parseInt(CwStorage.getItem('calendarDefaultMonth')) : void 0;
  $scope.currentViewName = function() {
    var ref;
    return ((ref = $scope.currentView()) != null ? ref.name : void 0) || defaultView;
  };
  $scope.attendanceAvailable = FeatureAvailabilityService.isAvailable('attendance');
  GTMService.trackPage('Calendar');
  displayItems = function(items) {
    if (!items) {
      return '';
    }
    return items.join(', ');
  };
  $scope.glossary = gym.attributes.glossary;
  $scope.eventSources = [
    {
      events: function(start,
    end,
    callback) {
        var endDate,
    eventsHeader,
    params,
    selectedEventType,
    selectedInstructor,
    selectedStyle,
    startDate;
        $scope.selectedInstructors = $scope.unableToManageOtherContacts ? [
          {
            id: window.currentUser.id,
            name: `${window.currentUser.first_name} ${window.currentUser.last_name}`
          }
        ] : _.compact([
          _.find($scope.instructors,
          {
            id: parseInt($location.search().instructor_id)
          })
        ]);
        $scope.selectedEventTypes = _.compact([
          _.find($scope.eventTypes,
          {
            id: parseInt($location.search().event_type_id)
          })
        ]);
        $scope.selectedStyles = _.compact([
          _.find($scope.styles,
          {
            id: parseInt($location.search().style_id)
          })
        ]);
        setDefaultDate(start);
        startDate = moment(start).subtract(1,
    'days').format('X');
        endDate = moment(end).add(1,
    'days').format('X');
        selectedLocation = $scope.selectedLocations[0] || {};
        selectedEventType = $scope.selectedEventTypes[0] || {};
        selectedInstructor = $scope.selectedInstructors[0] || {};
        selectedStyle = $scope.selectedStyles[0] || {};
        params = {
          'start': startDate,
          'end': endDate,
          'location_id': selectedLocation.id,
          'instructor_id': selectedInstructor.id,
          'event_type_id': selectedEventType.id,
          'style_id': selectedStyle.id,
          '_': new Date().getTime()
        };
        angular.extend(params,
    $scope.queryParams);
        if ($scope.currentViewName() === 'basicDay') {
          params.view = 'list';
          if (!$('.fc-day-header').children().length) {
            eventsHeader = `<div class="fc-agenda-head fc-event-hori">
  <span class="fc-event-time">Time</span>
  <span class="fc-event-title">Event</span>
  <span class="event-space">Places Left</span>
  <span class="fc-agenda-item event-instructor">Instructor</span>
  <span class="fc-agenda-item event-type">Type</span>
  <span class="fc-agenda-item event-classroom">Location</span>
</div>`;
            $('.fc-day-header').html(eventsHeader);
          }
        }
        return CalendarData.getList(params).then(function(data) {
          var events,
    matchingEvent;
          events = data.map(function(item) {
            var containerIndicatorClass,
    ref;
            item.title = $filter('limitString')(item.title,
    50);
            item.isFull = typeof item.vacancies_count === 'number' && item.vacancies_count <= 0 && $scope.currentViewName() !== 'basicDay';
            item.hasNote = !!((ref = item.notes) != null ? ref.length : void 0);
            item.isCancelled = !!item.cancelled;
            containerIndicatorClass = (function() {
              switch (false) {
                case !item.isCancelled:
                  return 'fc-event--cancelled';
                case !(item.hasNote && !item.isFull):
                  return 'fc-event--with-note';
                case !item.isFull:
                  return 'fc-event--full';
                default:
                  return '';
              }
            })();
            item.className = `event-${moment(item.start,
    'YYYY/MM/DD HH:mm').format('YYYY-MM-DD')} ${containerIndicatorClass}`;
            if (item.isCancelled) {
              item.color = '#9E9E9E';
              item.textColor = '#FFFFFF';
            } else {
              item.color = item.color || colors.primary;
              item.textColor = ContrastColor.get(item.color,
    {
                darkColor: '#303030'
              });
            }
            return item;
          });
          if ($stateParams.event_id && $stateParams.from === 'bulk_add_attendees') {
            matchingEvent = events.find(function(event) {
              return event.id === Number($stateParams.event_id);
            });
            if (matchingEvent) {
              $scope.showAttendeesModal(matchingEvent);
            }
          }
          return callback(events);
        });
      }
    }
  ];
  handlePopoverHide = function(e) {
    var el, parentElementClass, ref;
    el = e.target;
    parentElementClass = (el != null ? (ref = el.parentElement) != null ? ref.className : void 0 : void 0) || '';
    if (el && ('fc-widget-content' !== el.className && 'fc-widget-content' !== parentElementClass)) {
      $timeout(function() {
        return $scope.calendarItemOptions = {};
      });
      if ($state.current.name !== 'gym.calendar') {
        return $document.off('click', handlePopoverHide);
      }
    }
  };
  $document.on('click', handlePopoverHide);
  $scope.uiConfig = {
    calendar: {
      year: parseInt(CwStorage.getItem('calendarDefaultYear')) || void 0,
      month: defaultMonth,
      date: parseInt(CwStorage.getItem('calendarDefaultDate')) || void 0,
      editable: false,
      allDayDefault: false,
      allDaySlot: false,
      lazyFetching: false,
      defaultView: defaultView,
      firstDay: gym.attributes.gym_booking_detail.calendar_start_wday,
      minTime: ((ref = gym_config.calendar_display_hours_override) != null ? ref[0] : void 0) || 0,
      maxTime: ((ref1 = gym_config.calendar_display_hours_override) != null ? ref1[1] : void 0) || 24,
      contentHeight: defaultView === 'month' ? void 0 : 10000,
      viewDestroy: function() {
        return $location.search('view', void 0);
      },
      eventClick: function(event) {
        return $scope.showAttendeesModal(event);
      },
      dayClick: function(date, allDay, event, sourceView) {
        var calendar;
        if (/day/i.test(sourceView.name)) {
          if ($scope.permissions.manage_events) {
            return $scope.calendarItemOptions = {
              left: event.pageX - 63,
              top: event.pageY - 58,
              time: moment(date).unix()
            };
          }
        } else {
          calendar = $('#calendar');
          calendar.fullCalendar('changeView', 'agendaDay');
          return calendar.fullCalendar('gotoDate', date);
        }
      },
      loading: function(isLoading) {
        if (isLoading) {
          return loadingAnimation.show();
        } else {
          return loadingAnimation.hide();
        }
      },
      eventAfterAllRender: function(view) {
        $scope.calendarView = view;
        if (view.name === 'month' && view.calendar.options.contentHeight === 10000) {
          view.calendar.option('contentHeight', null);
        }
        if (view.name !== 'month' && view.calendar.options.contentHeight !== 10000) {
          return view.calendar.option('contentHeight', 10000);
        }
      },
      header: false,
      timeFormat: {
        day: 'h:mmt{ - h:mmt}',
        basicDay: 'h:mmt{ - h:mmt}'
      },
      columnFormat: {
        month: 'ddd',
        week: 'ddd d',
        day: 'dddd MMM d'
      },
      eventRender: function(event, element, view) {
        var background, bgDarker, classroomCancelledClass, elementIndex, eventContainer, existingTitle, firstLine, fullLabelClassName, hasNote, html, i, instructorCancelledClass, isMobile, isZeroBookingEvent, label, len, minHeight, noteElement, ref2, ref3, ref4, remaining, remainingWords, shouldShowFullLabel, time, titleEl, titleElement, titleText, top, typeCancelledClass, typeEmptyClass, vacancyDisplay, word, words;
        isMobile = window.innerWidth < 992;
        background = isMobile && event.isFull ? (bgDarker = lightenDarkenColor(event.color, -20), `repeating-linear-gradient(45deg, ${event.color}, ${event.color} 5px, ${bgDarker} 5px, ${bgDarker} 10px)`) : void 0;
        minHeight = view.name === 'basicDay' ? void 0 : '29px';
        element.css({
          'min-height': minHeight,
          'background': background
        });
        time = `${formatTime(event.start)}<span class='fc-event-time__end'> - ${formatTime(event.end)}</span>`;
        element.find('.fc-event-time').html(time);
        if (event.isCancelled) {
          element.addClass('fc-event--cancelled');
          element.css('background-color', '#9E9E9E');
          element.css('color', '#FFFFFF');
          element.find('.fc-event-skin').css('background-color', '#9E9E9E');
          element.find('.fc-event-skin').css('border-color', '#9E9E9E');
          element.css('text-decoration', 'line-through');
          element.css('text-decoration-skip-ink', 'none');
          existingTitle = element.find('.fc-event-title');
          if (existingTitle.length) {
            existingTitle.replaceWith(`<div class='fc-event-title fc-event-title--cancelled'>${event.title}</div>`);
          } else {
            element.find('.fc-event-inner').append(`<div class='fc-event-title fc-event-title--cancelled'>${event.title}</div>`);
          }
          element.find('.fc-event-time').addClass('fc-event-time--cancelled');
          if (view.name === 'month') {
            element.find('.fc-event-inner').append("<div class='fc-event__cancelled-inline'>CANCELLED</div>");
          } else if (view.name === 'agendaDay') {
            element.find('.fc-event-inner').append('<span class="fc-event__cancelled-badge fc-event__cancelled-badge--daily">CANCELLED</span>');
          }
        } else {
          if (!element.find('.fc-event-title').length) {
            element.find('.fc-event-inner').append(`<div class='fc-event-title'>${event.title}</div>`);
          }
        }
        if (moment(event.end).diff(event.start, 'hours') < 1 && ((ref2 = view.name) !== 'month' && ref2 !== 'basicDay')) {
          element.find('.fc-event-time').remove();
        }
        hasNote = event.hasNote && (element.height() >= 49 || !event.isFull || view.name === 'basicDay');
        if (hasNote) {
          noteElement = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="${event.textColor}" stroke-width="2" d="M1 23h15l7-7V1H1v22Zm14 0v-8h8"/></svg>`;
          element.find('.fc-event-inner').append(`<div class='fc-event__note'>${noteElement}</div>`);
        }
        if (event.isFull) {
          label = (ref3 = event.participant_limit) === 0 || ref3 === (void 0) || ref3 === null ? '0 PLACES' : 'FULL';
          fullLabelClassName = hasNote ? 'fc-event__full fc-event__full--with-note' : 'fc-event__full';
          shouldShowFullLabel = !event.isCancelled;
          if (shouldShowFullLabel) {
            if (label === '0 PLACES') {
              titleEl = element.find('.fc-event-title');
              titleText = titleEl.text().trim();
              words = titleText.split(' ');
              firstLine = '';
              remaining = '';
              for (i = 0, len = words.length; i < len; i++) {
                word = words[i];
                if ((firstLine + ' ' + word).trim().length <= 18) {
                  firstLine += ' ' + word;
                } else {
                  break;
                }
              }
              firstLine = firstLine.trim();
              remainingWords = words.slice(firstLine.split(' ').length);
              remaining = remainingWords.join(' ');
              html = `<span class='fc-event-title__first-line'>${firstLine}</span><br />${remaining}`;
              titleEl.empty().append(html);
            }
            element.find('.fc-event-inner').append(`<div class='${fullLabelClassName}'>${label}</div>`);
          }
        }
        if (view.name === 'basicDay') {
          isZeroBookingEvent = (ref4 = event.participant_limit) === 0 || ref4 === (void 0) || ref4 === null;
          top = 0;
          elementIndex = void 0;
          element.prevObject.each(function(index, item) {
            if (index === 0) {
              top = +item.style.top.replace('px', '');
            }
            if (item === element[0]) {
              elementIndex = index;
            }
            if (elementIndex === void 0) {
              return top = top + item.clientHeight + 1;
            }
          });
          eventContainer = $(element).find('.fc-event-inner');
          typeEmptyClass = event.event_type_names.length ? '' : 'event-type--empty';
          instructorCancelledClass = event.isCancelled ? 'event-instructor--cancelled' : '';
          typeCancelledClass = event.isCancelled ? 'fc-agenda-item--cancelled' : '';
          classroomCancelledClass = event.isCancelled ? 'fc-agenda-item--cancelled' : '';
          vacancyDisplay = event.isCancelled ? '-' : isZeroBookingEvent ? '-' : event.vacancies_count;
          eventContainer.append("<span class='event-vacancies'>" + vacancyDisplay + "</span>");
          eventContainer.append(`<span class='fc-agenda-item event-instructor ${instructorCancelledClass}'>` + displayItems(event.instructor_names) + "</span>");
          eventContainer.append(`<span class='fc-agenda-item event-type ${typeEmptyClass} ${typeCancelledClass}'>` + displayItems(event.event_type_names) + "</span>");
          eventContainer.append(`<span class='fc-agenda-item event-classroom ${classroomCancelledClass}'>` + event.classroom_name + "</span>");
          if (event.isCancelled) {
            titleElement = eventContainer.find('.fc-event-title');
            if (titleElement.length) {
              titleElement.append('<span class="fc-event__cancelled-badge">CANCELLED</span>');
            }
            element.find('.fc-event-time').addClass('fc-event-time--cancelled');
          }
          return element.css({
            top: top
          });
        }
      }
    }
  };
  $scope.currentView = function() {
    var ref2;
    return (ref2 = $scope.calendarView) != null ? ref2.calendar.getView() : void 0;
  };
  $scope.isFiltersAvailable = function() {
    return $scope.locations.length > 1 || $scope.instructors.length > 1;
  };
  refetchEvents = _.debounce(function() {
    return $scope.calendarView.calendar.refetchEvents();
  }, 300);
  $rootScope.$on('calendar:updated', function() {
    return $scope.calendarView.calendar.refetchEvents();
  });
  $scope.onLocationsChange = function(locations) {
    var location;
    location = locations[0] || {};
    CwStorage.setItem('selectedLocation', location.id);
    $location.search('location_id', location.id);
    $scope.selectedLocations = locations;
    return refetchEvents();
  };
  $scope.onInstructorsChange = function(instructors) {
    var instructor;
    instructor = instructors[0] || {};
    $scope.selectedInstructors = instructors;
    $location.search('instructor_id', instructor.id);
    return refetchEvents();
  };
  $scope.onEventTypesChange = function(eventTypes) {
    var eventType;
    eventType = eventTypes[0] || {};
    $scope.selectedEventTypes = eventTypes;
    $location.search('event_type_id', eventType.id);
    return refetchEvents();
  };
  $scope.onStylesChange = function(styles) {
    var style;
    style = styles[0] || {};
    $scope.selectedStyles = styles;
    $location.search('style_id', style.id);
    return refetchEvents();
  };
  $scope.onParamsChange = function() {
    CwStorage.setItem('calendarGeneralFilter', $scope.queryParams.general_filter);
    return refetchEvents();
  };
  $scope.showAttendeesModal = function(event) {
    return EventService.showAttendees(event, $location.search());
  };
  $scope.goToNew = function() {
    return EventService.addEvent();
  };
  $scope.setDailyAgenda = function() {
    return $scope.calendarView.calendar.changeView('basicDay');
  };
  $scope.getTitle = function() {
    var ref2, title;
    title = (ref2 = $scope.calendarView) != null ? ref2.title : void 0;
    if (title) {
      return title.replace('&#8212;', '—');
    }
  };
  $scope.toDate = function(date) {
    return $scope.calendarView.calendar.gotoDate(date.toDate());
  };
  setDefaultDate = function(date) {
    var calendarView, currentDay, currentMonth, currentYear, day, momentDate, month, ref2, year;
    calendarView = ((ref2 = $scope.currentView()) != null ? ref2.name : void 0) || defaultView;
    $scope.calendarViewName = (function() {
      switch (calendarView) {
        case 'month':
          return 'month';
        case 'agendaWeek':
          return 'week';
        case 'agendaDay':
          return 'day';
        case 'basicDay':
          return 'day';
      }
    })();
    currentYear = moment().format('YYYY');
    currentMonth = moment().format('M');
    currentDay = (function() {
      switch (calendarView) {
        case 'month':
          return moment().format('D');
        case 'agendaWeek':
          return moment().startOf('week').format('D');
        case 'agendaDay':
          return moment().format('D');
      }
    })();
    $scope.startDate = momentDate = calendarView === 'month' ? moment(date).add(2, 'w') : moment(date);
    year = momentDate.format('YYYY');
    month = momentDate.format('M');
    day = calendarView === 'month' ? void 0 : momentDate.format('D');
    CwStorage.setItem('calendarDefaultView', calendarView);
    if ((year === currentYear && month === currentMonth) && (calendarView === 'month' || day === currentDay)) {
      CwStorage.removeItem('calendarDefaultDate');
      CwStorage.removeItem('calendarDefaultMonth');
      return CwStorage.removeItem('calendarDefaultYear');
    } else {
      CwStorage.setItem('calendarDefaultDate', day);
      CwStorage.setItem('calendarDefaultMonth', month - 1);
      return CwStorage.setItem('calendarDefaultYear', year);
    }
  };
  $scope.onAddAppointmentClick = function(params) {
    GTMService.trackPage('Calendar', 'Add new appointment');
    return EventService.addAppointment(params);
  };
  $scope.onAddEventClick = function(params) {
    GTMService.trackPage('Calendar', 'Add new event');
    return EventService.addEvent(params);
  };
  if ($stateParams.no_kiosk_events) {
    params = $scope.permissions.manage_events ? {
      title: 'Class Kiosk Mode',
      message: ["Sorry! To use Class Kiosk Mode, you'll need at least one upcoming class / event in your calendar.", 'Click the button below to add an event to your calendar now.'],
      confirmButtonText: 'Add Event now',
      displayCancelButton: true
    } : {
      title: 'Class Kiosk Mode',
      message: ["Sorry! To use Class Kiosk Mode, you'll need at least one upcoming class / event in your calendar."],
      confirmButtonText: 'Close'
    };
    return MessageService.message(params).then(function() {
      if ($scope.permissions.manage_events) {
        return $scope.goToNew();
      } else {
        return $location.search('no_kiosk_events', void 0);
      }
    }, function() {
      return $location.search('no_kiosk_events', void 0);
    });
  }
}]);
